document.addEventListener('DOMContentLoaded', function () {
    (function (window, document) {

    // remove .modal-preload .modal-backdrop
    document.addEventListener('show.bs.modal', function () {
        let modalBackdrop = document.querySelector('.modal-preload.modal-backdrop');
        if (modalBackdrop) {
            modalBackdrop.remove();
        }
    });

    })(window, document);
});
